import React from 'react';

export const SvgCut = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.001 9l6.59-6.59c.89-.89 2.41-.26 2.41.99v.01c0 .38-.15.74-.41 1L15.001 11l-2-2zm-3.36-1.36c.29-.62.42-1.33.34-2.09-.19-1.73-1.54-3.2-3.26-3.49a4.008 4.008 0 00-4.66 4.65c.3 1.72 1.76 3.07 3.49 3.26.76.08 1.46-.05 2.09-.34l2.36 2.37-2.36 2.36c-.62-.29-1.33-.42-2.09-.34-1.73.19-3.2 1.54-3.49 3.26a4.002 4.002 0 004.65 4.65c1.72-.3 3.07-1.76 3.26-3.49.08-.76-.05-1.46-.34-2.09l2.37-2.35 7.59 7.59c.89.89 2.41.26 2.41-1v-.01c0-.37-.15-.73-.41-1L9.641 7.64zM6.001 8A2 2 0 116 4.001a2 2 0 01.001 4zm-2 10A2 2 0 108 18.001a2 2 0 00-3.999 0zm8-5.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5z"
      fill="currentColor"
    />
  </svg>
);
